const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnglishLevel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "21.1425 0.8223 537.4479 449.6876",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 118.5 0.5 C 139.942 -5.105 160.217 14.988 173.455 22.491 C 220.013 86.471 164.895 13.551 154.5 8.5 C 152.847 8.34 151.514 7.674 150.5 6.5 C 148.328 5.198 145.994 4.032 143.5 3 C 136.321 2.179 129.321 2.345 122.5 3.5 C 118.752 4.207 115.086 5.207 111.5 6.5 C 110.209 6.737 109.209 6.404 108.5 5.5 C 111.833 3.833 115.167 2.167 118.5 0.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 118.5,0.5 C 115.167,2.16667 111.833,3.83333 108.5,5.5C 106.442,6.93306 104.108,7.59973 101.5,7.5C 106.358,3.43009 112.025,1.09675 118.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 122.5 3.5 C 123.862 -5.837 177.076 6.423 181.137 37.841 C 189.47 34.698 143.243 -2.085 120.5 5.5 C 121.167 4.833 121.833 4.167 122.5 3.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 108.5,5.5 C 109.209,6.40397 110.209,6.73731 111.5,6.5C 102.933,11.0653 95.9331,17.3986 90.5,25.5C 89.2342,26.3624 87.9008,27.0291 86.5,27.5C 85.6971,26.5768 85.5304,25.5768 86,24.5C 89.2041,20.0477 92.3708,15.7143 95.5,11.5C 97.1475,9.6736 99.1475,8.34026 101.5,7.5C 104.108,7.59973 106.442,6.93306 108.5,5.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 85.5 1.5 C 86.618 1.373 107.488 4.235 111.543 5.281 C 111.876 5.614 107.122 7.219 107.455 7.552 C 106.63 8.438 105.63 9.026 104.455 8.807 C 100.159 7.616 81.084 5.831 75.939 11.061 C 73.154 11.494 74.381 9.266 72.5 11.5 C 71.708 10.3 71.708 8.967 72.5 7.5 C 75.888 3.642 80.222 1.642 85.5 1.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 122.5,3.5 C 121.833,4.16667 121.167,4.83333 120.5,5.5C 107.825,9.32961 97.8253,16.8296 90.5,28C 97.401,28.128 104.068,28.9614 110.5,30.5C 108.219,30.0773 106.552,30.744 105.5,32.5C 101.833,32.5 98.1667,32.5 94.5,32.5C 96.3691,31.8354 98.3691,31.1687 100.5,30.5C 95.4489,29.2214 90.4489,29.2214 85.5,30.5C 83.2362,31.2186 80.9029,31.552 78.5,31.5C 80.3885,30.678 82.3885,29.8447 84.5,29C 83.2089,27.7083 83.2089,26.5417 84.5,25.5C 84.5,26.8333 85.1667,27.5 86.5,27.5C 87.9008,27.0291 89.2342,26.3624 90.5,25.5C 95.9331,17.3986 102.933,11.0653 111.5,6.5C 115.086,5.2074 118.752,4.2074 122.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 95.5,11.5 C 92.3708,15.7143 89.2041,20.0477 86,24.5C 85.5304,25.5768 85.6971,26.5768 86.5,27.5C 85.1667,27.5 84.5,26.8333 84.5,25.5C 87.2044,20.0986 90.871,15.432 95.5,11.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 72.5 7.5 C 71.708 8.967 71.708 10.3 72.5 11.5 C 74.381 9.266 76.715 7.933 79.5 7.5 C 76.896 9.6 74.396 11.933 72 14.5 C 70.577 17.648 69.077 20.648 67.5 23.5 C 66.778 23.918 66.278 24.584 66 25.5 C 65.503 23.19 65.337 20.857 65.5 18.5 C 66.571 14.024 68.904 10.357 72.5 7.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 118.5 33.5 C 116.5 33.5 114.314 34.342 112.5 33.5 C 106.38 30.661 66.058 33.256 71.923 38.859 C 55.455 39.856 60.036 28.049 90.15 23.123 C 107.263 30.129 116.801 32.093 115 31.5 C 119.379 26.282 124.879 22.948 131.5 21.5 C 131.67 22.822 131.337 23.989 130.5 25 C 125.944 27.106 121.944 29.939 118.5 33.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 65.5 18.5 C 65.337 20.857 65.503 23.19 66 25.5 C 58.683 19.91 75.883 -2.569 86.578 3.15 C 72.608 9.079 60.643 31.999 68.5 34.5 C 70.323 33.253 72.323 32.586 74.5 32.5 C 73.15 33.824 73.317 34.824 75 35.5 C 78 34.5 81 33.5 84 32.5 C 85.03 32.164 85.53 31.497 85.5 30.5 C 90.449 29.221 95.449 29.221 100.5 30.5 C 98.369 31.169 96.369 31.835 94.5 32.5 C 72.267 35.758 54.6 46.425 41.5 64.5 C 41.5 63.833 41.5 63.167 41.5 62.5 C 42.75 60.068 44.25 57.734 46 55.5 C 48.363 53.634 50.53 51.634 52.5 49.5 C 58.891 44.789 65.558 40.289 72.5 36 C 69.271 35.414 66.271 35.914 63.5 37.5 C 64.091 36.849 64.757 36.182 65.5 35.5 C 62.858 29.714 62.858 24.047 65.5 18.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 85.5,30.5 C 85.5299,31.4972 85.0299,32.1639 84,32.5C 81,33.5 78,34.5 75,35.5C 73.3167,34.8235 73.1501,33.8235 74.5,32.5C 75.7079,31.7659 77.0413,31.4326 78.5,31.5C 80.9029,31.552 83.2362,31.2186 85.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 153.457 8.123 C 157.451 12.102 177.494 24.145 179.5 29.5 C 179.387 32.049 180.054 34.382 181.5 36.5 C 181.043 37.298 180.376 37.631 179.5 37.5 C 176.261 31.587 172.594 25.92 168.5 20.5 C 170.017 20.511 171.184 21.177 172 22.5 C 172.135 20.078 154.592 10.368 153.457 8.123 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 52.5,49.5 C 52.5,48.8333 52.5,48.1667 52.5,47.5C 54.7339,45.1097 57.4006,43.2763 60.5,42C 61.3366,40.9887 61.67,39.8221 61.5,38.5C 61.8417,37.6618 62.5084,37.3284 63.5,37.5C 66.2714,35.9138 69.2714,35.4138 72.5,36C 65.5578,40.2885 58.8912,44.7885 52.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 179.5 29.5 C 180.892 31.273 182.059 33.273 183 35.5 C 185.47 33.514 188.049 40.391 191.246 41.377 C 196.927 43.212 202.181 45.536 206.5 49.368 C 203.518 48.462 200.431 43.313 197.746 41.552 C 196.716 41.888 196.47 39.503 196.5 40.5 C 193.174 38.412 189.507 37.079 185.5 36.5 C 184.833 36.833 184.167 37.167 183.5 37.5 C 184.577 39.729 185.244 42.063 185.5 44.5 C 186.01 47.388 185.344 49.721 183.5 51.5 C 182.37 46.776 181.036 42.109 179.5 37.5 C 180.376 37.631 181.043 37.298 181.5 36.5 C 180.054 34.382 179.387 32.049 179.5 29.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 112.5,33.5 C 114.5,33.5 116.5,33.5 118.5,33.5C 112.564,39.9675 109.564,47.6342 109.5,56.5C 108.5,56.5 107.5,56.5 106.5,56.5C 106.47,48.288 108.47,40.6213 112.5,33.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 65.57 30.106 C 65.74 31.428 69.986 37.173 69.149 38.184 C 66.05 39.46 54.734 45.11 52.5 47.5 C 48.176 51.324 44.009 55.324 40 59.5 C 30.222 55.628 21.555 57.294 14 64.5 C 13.308 65.437 13.475 66.103 14.5 66.5 C 14.371 68.216 14.038 69.883 13.5 71.5 C 12.417 71.539 11.417 71.873 10.5 72.5 C 9.614 71.675 9.281 70.675 9.5 69.5 C 13.548 60.628 20.548 55.961 30.5 55.5 C 33.206 55.481 35.706 56.148 38 57.5 C 40.463 54.035 43.296 50.869 46.5 48 C 66.219 26.247 70.411 30.734 65.57 30.106 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 185.5,44.5 C 188.161,52.8581 188.994,61.5248 188,70.5C 187.751,71.624 187.251,72.624 186.5,73.5C 185.852,66.0919 184.852,58.7586 183.5,51.5C 185.344,49.7211 186.01,47.3878 185.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 218.772 61.131 C 222.927 68.442 224.989 68.477 227.5 76.5 C 227.702 78.989 229.491 91.498 228.289 93.675 C 227.413 91.417 223.957 79.242 222.5 77.5 C 222.5 77.167 222.5 76.833 222.5 76.5 C 223.822 61.409 232.521 81.071 229.166 91.885 C 227.423 87.401 231.273 100.62 229.016 96.437 C 232.105 87.796 202.78 48.185 192.463 42.153 C 190.679 41.11 198.113 51.439 205.106 68.803 C 213.418 89.44 181.046 36.557 181.204 35.492 C 192.014 28.137 218.294 61.646 218.772 61.131 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 52.5,47.5 C 52.5,48.1667 52.5,48.8333 52.5,49.5C 50.5298,51.6339 48.3631,53.6339 46,55.5C 44.2502,57.7343 42.7502,60.0676 41.5,62.5C 40.8826,62.6107 40.3826,62.944 40,63.5C 39.5348,62.0692 38.7014,60.9025 37.5,60C 33.1667,59.3333 28.8333,59.3333 24.5,60C 20.9965,62.0222 17.6632,64.1888 14.5,66.5C 13.475,66.1034 13.3083,65.4368 14,64.5C 21.5554,57.2942 30.2221,55.6276 40,59.5C 44.0091,55.324 48.1757,51.324 52.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 41.5,62.5 C 41.5,63.1667 41.5,63.8333 41.5,64.5C 40.1667,65.1667 38.8333,65.8333 37.5,66.5C 37.2172,65.7109 36.7172,65.0442 36,64.5C 34.9887,65.3366 33.8221,65.67 32.5,65.5C 32.8588,63.629 33.8588,62.129 35.5,61C 29.4653,59.5945 24.132,60.9279 19.5,65C 17.2659,67.0627 15.2659,69.2294 13.5,71.5C 14.038,69.8828 14.3713,68.2161 14.5,66.5C 17.6632,64.1888 20.9965,62.0222 24.5,60C 28.8333,59.3333 33.1667,59.3333 37.5,60C 38.7014,60.9025 39.5348,62.0692 40,63.5C 40.3826,62.944 40.8826,62.6107 41.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 37.5 66.5 C 35.234 70.637 35.856 67.847 34.789 72.378 C 33.793 72.292 30.671 79.748 30 80.5 C 28.487 84.188 26.987 87.855 25.5 91.5 C 24.778 91.918 24.278 92.584 24 93.5 C 21.985 91.522 22.152 89.688 24.5 88 C 23.956 87.283 23.289 86.783 22.5 86.5 C 24.516 78.804 27.85 71.804 32.5 65.5 C 33.822 65.67 34.989 65.337 36 64.5 C 36.717 65.044 37.217 65.711 37.5 66.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 219.5,69.5 C 221.821,71.0897 222.821,73.4231 222.5,76.5C 221.323,74.3206 220.323,71.9872 219.5,69.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 9.5,69.5 C 9.28099,70.675 9.61432,71.675 10.5,72.5C 11.4168,71.8728 12.4168,71.5394 13.5,71.5C 9.46511,82.105 10.4651,92.2716 16.5,102C 15.3521,103.726 14.1855,103.559 13,101.5C 10.4665,98.1474 8.63318,94.4807 7.5,90.5C 7.5,89.8333 7.5,89.1667 7.5,88.5C 8.22158,88.9175 8.72158,89.5842 9,90.5C 9.49902,86.1794 9.66568,81.8461 9.5,77.5C 8.5,77.5 7.5,77.5 6.5,77.5C 6.73292,74.4582 7.73292,71.7916 9.5,69.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 6.5 77.5 C 7.5 77.5 8.5 77.5 9.5 77.5 C 9.666 81.846 9.499 86.179 9 90.5 C 8.722 89.584 8.222 88.918 7.5 88.5 C 7.737 87.209 7.404 86.209 6.5 85.5 C 5.837 85.077 5.337 80.407 6.5 77.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 72.436 37.529 C 60.84 39.325 18.577 86.299 25.5 94.5 C 25.5 93.5 25.5 92.5 25.5 91.5 C 24.197 99.001 26.634 88.3 32.341 76.536 C 35.823 69.358 37.498 61.531 38.14 59.896 C 38.811 59.144 71.44 37.443 72.436 37.529 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 210.378 54.263 C 212.428 66.082 228.961 76.147 230.5 89.5 C 230.266 94.9 229.6 100.233 228.5 105.5 C 233.469 107.18 215.317 55.62 210.255 54.626 C 197.847 35.758 229.959 80.478 226.236 88.238 C 227.431 83.987 228.695 94.915 228.5 90.5 C 228.819 85.637 228.486 80.97 227.5 76.5 C 224.989 68.477 214.533 61.574 210.378 54.263 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 36.236 58.01 C 37.025 58.293 23.956 87.283 24.5 88 C 22.152 89.688 21.985 91.522 24 93.5 C 24.278 92.584 24.778 91.918 25.5 91.5 C 25.5 92.5 25.5 93.5 25.5 94.5 C 23.276 96.956 21.276 96.456 19.5 93 C 20.423 90.71 23.574 72.911 36.236 58.01 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 183.5 118.5 C 182.624 118.369 190.86 128.622 190.403 129.42 C 191.03 130.337 188.312 131.592 188.351 132.675 C 184.117 128.207 175.599 112.699 174.5 106.5 C 175.822 106.33 176.989 106.663 178 107.5 C 179.558 111.363 181.391 115.03 183.5 118.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 6.754 75.325 C 7.658 76.034 7.737 87.209 7.5 88.5 C 7.5 89.167 9.535 90.596 9.535 91.263 C 7.373 94.903 5.364 97.886 4.526 102.246 C 3.806 109.282 2.447 116.536 3.5 123.5 C 2.455 121.23 1.121 119.23 -0.5 117.5 C -2.501 113.507 -2.623 104.546 -1.772 98.448 C -0.862 91.925 4.297 80.47 6.754 75.325 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 183.5 118.5 C 185.04 123.699 193.169 128.179 199.807 129.281 C 199.807 130.281 196.5 129.5 196.5 130.5 C 195.178 130.67 194.011 130.337 193 129.5 C 192.392 131.066 191.558 132.4 190.5 133.5 C 188.137 131.917 188.137 130.084 190.5 128 C 189.906 127.536 189.239 127.369 188.5 127.5 C 185.911 126.581 183.911 124.914 182.5 122.5 C 182.461 121.417 182.127 120.417 181.5 119.5 C 181.957 118.702 182.624 118.369 183.5 118.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 0.263 101.22 C 1.885 102.95 2.455 121.23 3.5 123.5 C 4.319 129.309 10.072 139.394 10.587 140.929 C 8.779 142.347 4.042 142.058 4.517 144.64 C 3.535 143.28 2.306 134.383 -0.5 127.5 C -4.856 107.834 -0.219 102.746 0.263 101.22 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 189.123 132.026 C 189.123 131.026 190.141 128.754 190.141 127.754 C 199.19 128.827 213.549 126.24 220.5 120.5 C 221.754 122.259 221.421 123.759 219.5 125 C 212.543 130.157 197.5 133.516 189.123 132.026 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 228.684 99.711 C 230.615 101.864 241.553 103.426 238.57 125.754 C 239.522 131.297 220.769 157.107 211.211 156.28 C 208.286 153.968 216.081 150.188 219.5 148.5 C 220.776 147.386 209.075 154.272 207.799 153.386 C 228.977 144.578 238.862 105.465 228.684 99.711 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 188.5 127.5 C 189.239 127.369 189.906 127.536 190.5 128 C 188.137 130.084 191.698 127.847 194.061 129.43 C 189.832 128.524 181.47 173.737 180.939 182.349 C 179.309 183.875 182.037 151.026 182 153.5 C 180.989 154.337 179.822 154.67 178.5 154.5 C 180.432 144.971 183.766 135.971 188.5 127.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 5.5 130.5 C 10.445 141.111 18.111 149.111 28.5 154.5 C 26.436 154.313 24.436 153.813 22.5 153 C 18.365 150.365 14.699 147.198 11.5 143.5 C 10.417 144.365 10.251 145.365 11 146.5 C 13.782 148.771 28.413 163.138 29.964 166.201 C 25.589 162.827 9.458 147.126 6.5 142.5 C 6.715 140.821 6.048 139.821 4.5 139.5 C 3.89 138.609 3.557 137.609 3.5 136.5 C 3.025 133.918 3.692 131.918 5.5 130.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 4.5 139.5 C 6.048 139.821 6.715 140.821 6.5 142.5 C 4.838 144.224 7.907 140.032 7.57 142.641 C 4.217 142.076 3.368 160.006 8.044 166.894 C 6.609 165.604 3.065 155.544 2.5 153.5 C 2.167 154.167 1.833 154.833 1.5 155.5 C 2.586 158.42 3.252 161.42 3.5 164.5 C -0.766 156.013 -0.433 147.68 4.5 139.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 231.201 129.729 C 232.477 130.615 220.776 147.386 219.5 148.5 C 217.146 150.188 215.146 152.188 213.5 154.5 C 212.486 155.674 211.153 156.34 209.5 156.5 C 209.631 155.624 209.298 154.957 208.5 154.5 C 206.929 155.309 185.167 158.186 183.405 158.043 C 201.207 157.086 233.449 142.059 231.201 129.729 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 79.5 155.5 C 79.715 153.821 79.048 152.821 77.5 152.5 C 74.364 149.016 72.031 145.016 70.5 140.5 C 71 140.167 71.5 139.833 72 139.5 C 74.418 143.921 77.584 147.754 81.5 151 C 85.784 152.654 90.118 154.154 94.5 155.5 C 93.652 156.991 97.152 159.947 95.333 159.789 C 91.736 158.7 83.237 155.745 79.5 155.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 28.5 154.5 C 28.5 154.833 28.5 155.167 28.5 155.5 C 26.833 155.5 25.167 155.5 23.5 155.5 C 23.5 156.5 35.71 160.298 35.71 161.298 C 34.782 161.127 39.167 167.313 30.166 158.789 C 33.951 169.681 17.403 156.019 11.649 148.395 C 10.098 145.332 13.782 148.771 11 146.5 C 10.251 145.365 10.417 144.365 11.5 143.5 C 14.699 147.198 18.365 150.365 22.5 153 C 24.436 153.813 26.436 154.313 28.5 154.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 170.5 151.5 C 166.505 155.49 162.171 159.156 157.5 162.5 C 159.243 164.038 161.243 165.038 163.5 165.5 C 163.179 167.048 162.179 167.715 160.5 167.5 C 160.609 171.391 161.609 175.058 163.5 178.5 C 163.167 178.833 162.833 179.167 162.5 179.5 C 160.828 176.045 161.959 177.798 160.298 174.587 C 159.651 171.614 150.257 165.399 148.904 165.754 C 148.195 164.85 152.791 164.263 151.5 164.5 C 157.238 160.938 162.571 156.771 167.5 152 C 168.448 151.517 169.448 151.351 170.5 151.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 28.5,155.5 C 33.1993,157.842 38.1993,159.175 43.5,159.5C 49.3193,160.328 55.3193,160.828 61.5,161C 60.5842,161.278 59.9175,161.778 59.5,162.5C 57.5168,162.157 56.1834,162.824 55.5,164.5C 51.5,164.5 47.5,164.5 43.5,164.5C 37.4921,162.167 31.1587,160.167 24.5,158.5C 24.1667,158.5 23.8333,158.5 23.5,158.5C 23.5,157.5 23.5,156.5 23.5,155.5C 25.1667,155.5 26.8333,155.5 28.5,155.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 28.5,155.5 C 28.5,155.167 28.5,154.833 28.5,154.5C 40.5585,158.52 52.8919,159.52 65.5,157.5C 65.3893,158.117 65.056,158.617 64.5,159C 57.5079,159.5 50.5079,159.666 43.5,159.5C 38.1993,159.175 33.1993,157.842 28.5,155.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 171.5 143.5 C 173.288 143.215 168.448 151.517 167.5 152 C 162.571 156.771 157.238 160.938 151.5 164.5 C 146.746 166.508 142.079 168.508 137.5 170.5 C 136.127 170.657 134.793 170.49 133.5 170 C 135.491 169.626 137.158 168.793 138.5 167.5 C 144.579 164.626 150.579 161.459 156.5 158 C 158.424 156.25 160.091 154.417 161.5 152.5 C 167.882 147.975 168.874 146.147 171.5 143.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 219.928 149.886 C 220.219 150.126 214.984 155.876 210.156 157.674 C 206.925 158.877 203.3 159.635 201.5 160 C 195.52 161.212 184.974 162.737 181.667 161.263 C 181.497 159.941 181.576 155.213 182.413 154.202 C 174.995 156.013 191.749 157.219 203.5 155.5 C 205.262 155.643 214.051 150.985 215.622 150.176 C 216.42 150.633 220.059 149.01 219.928 149.886 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 161.5,152.5 C 160.091,154.417 158.424,156.25 156.5,158C 150.579,161.459 144.579,164.626 138.5,167.5C 134.214,168.707 129.88,169.707 125.5,170.5C 138.266,166.117 150.266,160.117 161.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 77.5 152.5 C 79.048 152.821 79.715 151.277 79.5 152.956 C 79.158 153.794 92.736 156.926 91.745 156.754 C 86.867 157.619 80.564 159.556 74.345 162.121 C 63.902 166.429 31.547 164.222 36.098 161.737 C 36.516 161.015 60.584 161.278 61.5 161 C 55.319 160.828 49.319 160.328 43.5 159.5 C 50.508 159.666 57.508 159.5 64.5 159 C 65.056 158.617 65.389 158.117 65.5 157.5 C 69.429 155.852 73.429 154.185 77.5 152.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 77.5,156.5 C 70.9264,160.917 63.5931,163.583 55.5,164.5C 56.1834,162.824 57.5168,162.157 59.5,162.5C 65.6061,160.687 71.6061,158.687 77.5,156.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 3.465 149.088 C 0.683 154.451 11.876 173.708 17.903 172.368 C 17.753 175.926 13.427 170.644 17.5 172.5 C 13.968 171.146 21.74 177.54 18.938 174.894 C 18.271 175.561 7.333 167.833 8 168.5 C 9.707 170.037 11.207 171.704 12.5 173.5 C 8.522 171.522 5.522 168.522 3.5 164.5 C 3.252 161.42 2.586 158.42 1.5 155.5 C 1.833 154.833 2.167 154.167 2.5 153.5 C 3.065 155.544 2.03 147.798 3.465 149.088 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 24.5 158.5 C 31.159 160.167 37.492 162.167 43.5 164.5 C 39.124 164.091 34.79 163.425 30.5 162.5 C 25.661 167.074 39.714 193.087 52.358 194.358 C 50.339 196.108 28.878 183.033 24.5 173.5 C 25.415 169.71 24.255 162.876 25.719 158.711 C 24.277 158.334 25.058 159.79 24.5 158.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 100.673 175.131 C 98.378 175.435 58.871 168.804 60.5 170.5 C 56.218 169.343 55.885 168.01 59.5 166.5 C 60.416 166.543 100.256 174.507 100.673 175.131 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 151.5,164.5 C 152.791,164.263 153.791,164.596 154.5,165.5C 148.94,167.779 143.274,169.779 137.5,171.5C 137.5,171.167 137.5,170.833 137.5,170.5C 142.079,168.508 146.746,166.508 151.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 61.5 167.5 C 65.637 168.579 69.191 170.359 74.5 170.5 C 74.328 171.492 74.662 172.158 75.5 172.5 C 75.5 172.833 75.5 173.167 75.5 173.5 C 73.833 173.5 72.167 173.5 70.5 173.5 C 66.838 172.834 63.505 171.395 60.5 170.5 C 58.871 168.804 59.204 167.804 61.5 167.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 138.5,167.5 C 137.158,168.793 135.491,169.626 133.5,170C 134.793,170.49 136.127,170.657 137.5,170.5C 137.5,170.833 137.5,171.167 137.5,171.5C 131.614,173.137 125.614,174.137 119.5,174.5C 117.801,174.66 116.134,174.494 114.5,174C 116.058,173.79 117.391,173.29 118.5,172.5C 120.781,172.923 122.448,172.256 123.5,170.5C 124.167,170.5 124.833,170.5 125.5,170.5C 129.88,169.707 134.214,168.707 138.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 184.5 147.5 C 181.935 156.993 186.883 133.082 186.114 142.923 C 181.969 153.023 179.861 194.804 183.009 201.535 C 182.342 201.535 174.808 193.395 174.141 193.395 C 174.084 192.286 180.11 197.391 179.5 196.5 C 179.672 195.508 179.592 197.386 178.754 197.044 C 176.194 183.655 175.94 167.778 178.5 154.5 C 179.822 154.67 180.989 154.337 182 153.5 C 182.037 151.026 182.87 149.026 184.5 147.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 74.5,170.5 C 78.6836,170.851 82.6836,171.518 86.5,172.5C 82.8333,172.5 79.1667,172.5 75.5,172.5C 74.6618,172.158 74.3284,171.492 74.5,170.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 75.5,172.5 C 79.1667,172.5 82.8333,172.5 86.5,172.5C 87.1667,172.5 87.8333,172.5 88.5,172.5C 96.104,174.307 104.104,175.14 112.5,175C 106.175,175.5 99.8421,175.666 93.5,175.5C 87.2614,175.724 81.2614,175.057 75.5,173.5C 75.5,173.167 75.5,172.833 75.5,172.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 88.5 172.5 C 93.754 173.345 98.673 174.293 112.5 172.5 C 114.483 172.243 116.5 172.5 118.5 172.5 C 117.391 173.29 116.058 173.79 114.5 174 C 116.134 174.494 117.801 174.66 119.5 174.5 C 118.167 175.167 116.833 175.833 115.5 176.5 C 107.981 176.825 100.648 176.492 93.5 175.5 C 99.842 175.666 106.175 175.5 112.5 175 C 104.104 175.14 96.104 174.307 88.5 172.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 163.5 165.5 C 165.924 166.548 168.257 166.884 170.5 166.5 C 167.714 167.956 164.714 168.956 161.5 169.5 C 163.236 174.634 164.219 180.906 167.5 184.5 C 166.167 184.5 165.5 185.167 165.5 186.5 C 151.42 166.255 145.618 159.056 151.395 163.141 C 153.056 166.352 152.688 160.274 154.36 163.729 C 154.693 163.396 163.167 178.833 163.5 178.5 C 156.644 176.713 160.152 171.543 160.5 167.5 C 162.179 167.715 163.179 167.048 163.5 165.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 17.5 172.5 C 19.806 172.993 22.139 173.326 24.5 173.5 C 26.782 173.603 29.115 173.603 31.5 173.5 C 31.5 173.833 31.5 174.167 31.5 174.5 C 31.387 177.049 32.054 179.382 33.5 181.5 C 33.167 181.833 32.833 182.167 32.5 182.5 C 31.167 180.5 29.833 178.5 28.5 176.5 C 24.217 175.508 19.761 176.582 15.5 175.5 C 9.272 173.918 4.98 167.885 5.378 166.632 C 4.085 164.836 9.707 170.037 8 168.5 C 7.333 167.833 7.333 167.167 8 166.5 C 10.802 169.146 13.968 171.146 17.5 172.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 137.5,171.5 C 130.619,174.653 123.286,176.32 115.5,176.5C 116.833,175.833 118.167,175.167 119.5,174.5C 125.614,174.137 131.614,173.137 137.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 70.5 173.5 C 72.167 173.5 73.833 173.5 75.5 173.5 C 81.261 175.057 87.261 175.724 93.5 175.5 C 84.786 177.835 80.37 171.542 97.979 173.119 C 101.595 173.443 114.909 173.028 127.653 169.641 C 137.391 167.053 146.689 161.459 151.701 160.693 C 161.595 159.18 159.306 165.697 134.069 173.956 C 130.587 175.289 126.349 175.602 122.001 176.489 C 109.079 179.126 97.05 177.167 90.5 178.5 C 88.404 181.263 86.07 183.597 83.5 185.5 C 82.833 185.167 82.167 184.833 81.5 184.5 C 83.477 182.186 85.477 179.853 87.5 177.5 C 81.593 176.656 75.926 175.323 70.5 173.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 31.5 174.5 C 27.828 177.961 37.291 188.85 58.762 195.351 C 57.679 195.312 41.417 189.127 40.5 188.5 C 39.703 188.957 37.843 190.896 37.974 191.772 C 32.826 188.789 30.352 183.35 27.5 178 C 23.234 177.811 19.234 176.977 15.5 175.5 C 19.884 175.174 24.217 175.508 28.5 176.5 C 29.833 178.5 31.167 180.5 32.5 182.5 C 32.833 182.167 33.167 181.833 33.5 181.5 C 32.054 179.382 31.387 177.049 31.5 174.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 87.605 177.123 C 88.272 177.456 93.008 177.79 93.675 178.123 C 88.146 183.534 71.304 194.245 63.5 195.5 C 60.452 193.881 57.119 192.881 53.5 192.5 C 64.204 193.586 79.669 183.569 87.605 177.123 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 167.5 184.5 C 170.537 188.537 174.203 191.871 178.5 194.5 C 178.328 195.492 179.679 195.649 180.517 195.991 C 181.127 196.882 178.662 195.339 178.719 196.448 C 175.362 164.911 179.806 194.668 180.536 198.992 C 178.523 197.067 165.353 193.878 159.305 185.122 C 154.974 178.852 155.594 167.622 146.676 166.659 C 156.088 162.019 166.167 184.5 167.5 184.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(2.226078987121582, 0, 0, 2.226078987121582, 26.374650955200195, 1.8769960403442383)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "rgb(136, 131, 246)",
      strokeWidth: 4
    },
    d: "M 43.5 189.5 C 46.704 190.901 50.037 191.901 53.5 192.5 C 57.119 192.881 60.452 193.881 63.5 195.5 C 54.614 197.608 44.833 196.959 37.719 191.517 C 37.588 190.641 39.703 188.957 40.5 188.5 C 41.417 189.127 42.417 189.461 43.5 189.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglishLevel);
export default __webpack_public_path__ + "static/media/EnglishLevel.d7b89b7241a3cf11f770b0afad6fe6fa.svg";
export { ForwardRef as ReactComponent };